import { CaseListItem } from '@debbie/common/dist/cases/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { Button } from '@debbie/iris/dist/components/index.js'
import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { styled } from 'styled-components'

interface Props {
  case: CaseListItem
}

const CaseSummary = (props: Props) => {
  const history = useHistory()
  const lang = useSelector((s: RootState) => s.lang)
  return (
    <TableRow key={props.case.id}>
      <td>{props.case.id}</td>
      <td>
        <Button
          onClick={() => {
            const path = `/cases/${props.case.id}`
            history.push(path)
          }}
          className="ui-test-260b3416"
        >
          {lang.debtorWeb.seeMore}
        </Button>
      </td>
    </TableRow>
  )
}

export default CaseSummary

const TableRow = styled.tr`
  height: 55px;

  & > td > button {
    display: inline-block;
    color: #fff;
  }
`
